import { Banner } from "../../components/cards/banner";
import { Layout } from "../../components/layout";

const termsAndConditions = [
  {
    title: "INTRODUCTION",
    content: {
      text: `These Terms and Conditions ("Terms") govern your access to and use of the MyCardGlobal website, digital card services, and other related financial services provided by MyCardGlobal ("we," "our," or "us"). By using our services, you agree to be bound by these Terms and our Privacy Policy.`,
      points: [],
    },
  },
  {
    title: "ELIGIBILITY",
    content: {
      text: `To use our services, you must:`,
      points: [
        {
          text: "Be at least 18 years old (or the legal age of majority in your jurisdiction).",
          points: [],
        },
        {
          text: "Provide accurate and complete registration information.",
          points: [],
        },
        {
          text: "Agree to comply with all applicable local and international financial regulations.",
          points: [],
        },
      ],
    },
  },
  {
    title: "SERVICES",
    content: {
      text: `MyCardGlobal offers digital financial services, including but not limited to:`,
      points: [
        {
          text: "Digital card issuance and management.",
          points: [],
        },
        {
          text: "Cross-border payments and transfers.",
          points: [],
        },
        {
          text: "Access to online financial tools via our website and platform.",
          points: [],
        },
        {
          text: "We reserve the right to modify, suspend, or discontinue any service at our sole discretion, with or without notice.",
          points: [],
        },
      ],
    },
  },
  {
    title: "USER RESPONSIBILITIES",
    content: {
      text: `As a user, you agree to:`,
      points: [
        {
          text: "Use the platform only for lawful purposes.",
          points: [],
        },
        {
          text: "Maintain the confidentiality of your account credentials.",
          points: [],
        },
        {
          text: "Immediately report any unauthorized use or security breaches.",
          points: [],
        },
        {
          text: "Not use our services for fraudulent, illegal, or malicious activities.",
          points: [],
        },
      ],
    },
  },
  {
    title: "FEES AND CHARGES",
    content: {
      text: `Some of our services may be subject to fees, which will be communicated to you clearly before use. You agree to pay any applicable charges as outlined during your transactions.`,
      points: [],
    },
  },
  {
    title: "PRIVACY",
    content: {
      text: `We are committed to protecting your personal information. Please review our Privacy Policy to understand how we collect, use, and protect your data.`,
      points: [],
    },
  },
  {
    title: "INTELLECTUAL PROPERTY",
    content: {
      text: `All content, branding, software, and technology on the MyCardGlobal platform are the exclusive property of MyCardGlobal and are protected by intellectual property laws. You may not reproduce, modify, or distribute any part of the platform without our prior written consent.`,
      points: [],
    },
  },
  {
    title: "LIMITATION OF LIABILITY",
    content: {
      text: `MyCardGlobal shall not be liable for any indirect, incidental, or consequential damages arising from your use of or inability to use our services. We provide services on an “as is” and “as available” basis.`,
      points: [],
    },
  },
  {
    title: "TERMINATION",
    content: {
      text: `We reserve the right to suspend or terminate your account and access to our services at any time, without prior notice, if you violate these Terms or any applicable laws.`,
      points: [],
    },
  },
  {
    title: "GOVERNING LAW",
    content: {
      text: `These Terms are governed by and construed in accordance with the laws of [Insert Jurisdiction], without regard to its conflict of law principles.`,
      points: [],
    },
  },
  {
    title: "AMENDMENTS",
    content: {
      text: `We may update these Terms from time to time. Continued use of our services after changes are made constitutes your acceptance of the updated Terms.`,
      points: [],
    },
  },
  {
    title: "CONTACT US",
    content: {
      text: `If you have any questions or concerns about these Terms, please contact us at:`,
      points: [
        {
          text: (
            <>
              Email:{" "}
              <span className="text-primary">support@mycardglobal.com</span>
            </>
          ),
          points: [],
        },
        {
          text: (
            <>
              Website:{" "}
              <span className="text-primary">www.mycardglobal.com</span>
            </>
          ),
          points: [],
        },
      ],
    },
  },
];

export const TermsPage = () => {
  return (
    <Layout>
      <div className="w-full">
        <Banner
          src="/assets/images/terms.svg"
          text={
            <>
              TERMS AND <br /> CONDITIONS
            </>
          }
        />

        <div
          className="
          max-width
          py-[64px] lg:py-[96px]
          text-base lg:text-lg leading-[24px] lg:leading-[28px]
          text-grey-700
          "
        >
          <div className="px-4 lg:px-8 flex flex-col gap-10">
            <p>
              Welcome to MyCardGlobal. By accessing or using our platform at{" "}
              <span className="text-primary">www.mycardglobal.com</span>, you
              agree to comply with and be bound by the following Terms and
              Conditions. Please read them carefully.
            </p>

            <p
              className="
              lg:text-[36px] lg:leading-[42px]
              font-bold
              "
            >
              TERMS AND CONDITIONS
              <br />
              <br />
              FOR MYCARD GLOBAL PLATFORM
            </p>

            <div className="flex flex-col gap-8">
              {termsAndConditions.map((tC, idx) => {
                return (
                  <div key={`${idx}`} className="flex flex-col gap-4">
                    <p className="text-[18px ]lg:text-[24px] leading-[28px] lg:leading-[30px] font-bold text-grey-900">
                      {idx + 1}. {tC.title}
                    </p>

                    <p>{tC.content.text}</p>

                    {tC.content.points.length > 0 &&
                      tC.content.points[0].points.length > 0 && (
                        <ul
                          className="list-dic flex flex-col gap-4"
                          //   style={{ listStyleType: "lower-alpha" }}
                        >
                          {tC.content.points.map((p, nIdx) => {
                            return (
                              <li
                                key={`${idx}-${nIdx}`}
                                className="flex flex-col gap-4"
                              >
                                <p className="font-medium text-grey-700">
                                  {p.text}
                                </p>
                                <ul className="list-disc list-inside px-3">
                                  {p.points.map((p, nIdx) => {
                                    return <li key={`${idx}-${nIdx}`}>{p}</li>;
                                  })}
                                </ul>
                              </li>
                            );
                          })}
                        </ul>
                      )}

                    {tC.content.points.length > 0 &&
                      tC.content.points[0].points.length <= 0 && (
                        <ul className="list-disc list-inside px-3">
                          {tC.content.points.map((p, nIdx) => {
                            return <li key={`${idx}-${nIdx}`}>{p.text}</li>;
                          })}
                        </ul>
                      )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
